import Vue from "vue";
import Vuex from "vuex";
import Auth from "./auth";
import Notification from "./notification";
import User from "./user";
import Empresa from "./empresa";
import Header from "./header";
import Agenda from "./agenda";
import Tarefa from "./tarefa";
import Conteudo from "./conteudo";
import Creation from './creation'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    agenda: Agenda,
    auth: Auth,
    conteudo: Conteudo,
    creation: Creation,
    empresa: Empresa,
    header: Header,
    notification: Notification,
    tarefa: Tarefa,
    user: User,
  }
});
